import { CSSProperties, ReactNode } from "react"
import { ChipContainerRoot } from "./styles"

type TChipContainerProps = {
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export const ChipContainer = ({
  className,
  style,
  children
}: TChipContainerProps) => {
  return (
    <ChipContainerRoot className={className} style={style}>
      {children}
    </ChipContainerRoot>
  )
}
